import React from "react";
import "../css/footer.css";

export default function footer() {
  return (
    <div>
      <div className="footer web">
        <div className="container ">
          <div className="footerContainer">
            <div className="item-a">
              <div>
                Giấy phép trò chơi
                <img
                  src="./assets/gaming license/tick.svg"
                  alt=""
                  className="tick"
                />
              </div>
              <img
                src="./assets/gaming license/curacao.svg"
                alt=""
                className="curacao"
              />
              <div style={{ "padding-right": "40%" }}>
                Được quy định và cấp phép bởi Chính phủ Curacao và hoạt động
                theo Giấy phép chính của Nhà cung cấp dịch vụ trò chơi, N.V. #
                365 / JAZ
              </div>
            </div>
            <div className="item-b">
              <div>Theo dõi chúng tôi</div>
              <span>
                <img
                  src="./assets/follow us/fb.svg"
                  alt=""
                  className="followUs"
                />
                <img
                  src="./assets/follow us/twitter.svg"
                  alt=""
                  className="followUs"
                />
                <img
                  src="./assets/follow us/instagram.svg"
                  alt=""
                  className="followUs"
                />
                <img
                  src="./assets/follow us/youtube.svg"
                  alt=""
                  className="followUs"
                />
              </span>
            </div>
            <div className="item-c">
              <div>Chơi có trách nhiệm</div>
              <span>
                <img
                  src="./assets/responsible gaming/18+.svg"
                  alt=""
                  className="responsibleGaming"
                />
                <img
                  src="./assets/responsible gaming/gamcare-ov.svg"
                  alt=""
                  className="responsibleGaming"
                />
                <img
                  src="./assets/responsible gaming/begambleaware-ov.svg"
                  alt=""
                  className="responsibleGaming"
                />
              </span>
            </div>
            <div className="horizontalLine"></div>
            <div></div>
            <div></div>
            <div>Bản quyền © 2022 BK8™ Tất cả quyền được bảo lưu</div>
          </div>
        </div>
      </div>
      <div class="footer mobile">
        <div class="gamingLicense">
          <div>
            Giấy phép trò chơi
            <img src="./assets/gaming license/tick.svg" alt="" class="tick" />
          </div>
          <img
            src="./assets/gaming license/curacao.svg"
            alt=""
            class="curacao"
          />
          <div>
            Được quy định và cấp phép bởi Chính phủ Curacao và hoạt động theo
            Giấy phép chính của Nhà cung cấp dịch vụ trò chơi, N.V. # 365 / JAZ
          </div>
        </div>
        <div class="socialMedia">
          <div class="">
            <div>Theo dõi chúng tôi</div>
            <span>
              <img src="./assets/follow us/fb.svg" alt="" class="followUs" />
              <img
                src="./assets/follow us/twitter.svg"
                alt=""
                class="followUs"
              />
              <img
                src="./assets/follow us/instagram.svg"
                alt=""
                class="followUs"
              />
              <img
                src="./assets/follow us/youtube.svg"
                alt=""
                class="followUs"
              />
            </span>
          </div>
          <div class="">
            <div>Chơi có trách nhiệm</div>
            <span>
              <img
                src="./assets/responsible gaming/18+.svg"
                alt=""
                class="responsibleGaming"
              />
              <img
                src="./assets/responsible gaming/gamcare-ov.svg"
                alt=""
                class="responsibleGaming"
              />
              <img
                src="./assets/responsible gaming/begambleaware-ov.svg"
                alt=""
                class="responsibleGaming"
              />
            </span>
          </div>
        </div>
        <div class="horizontalLine"></div>
        <div>Bản quyền © 2022 BK8™ Tất cả quyền được bảo lưu</div>
      </div>
    </div>
  );
}
